var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { forwardRef } from 'react';
import './input-checkbox.scss';
export var InputCheckbox = forwardRef(function (_a, ref) {
    var id = _a.id, onToggle = _a.onToggle, dataValue = _a.dataValue, checked = _a.checked;
    return (React.createElement("div", { className: "c-input-checkbox" },
        React.createElement("input", __assign({ id: id, type: "checkbox", ref: ref }, (dataValue && { 'data-value': dataValue }), { onChange: onToggle, checked: checked }))));
});
InputCheckbox.displayName = 'InputCheckbox';
